/* The formula, then how to read it and where it shows up.
 *
 * A formula is markup, not prose: the tables carry <sub>, <sup> and &nbsp;
 * because that is what a formula is made of. This is the single place in the
 * app where markup is injected, and it is always authored content from
 * src/i18n/locales — never input.
 */
export function Formula({ markup }: { markup: string }) {
  return <div className="fx" dangerouslySetInnerHTML={{ __html: markup }} />;
}
